/*
 * Copyright (c) 2023 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { JsonApiResource } from '@irian-ro/abstract-resource';
import { LegalEntityModel } from '@well/common-libs/legal-entity-management/domain-model';
import { CompanyLegalEntityLocalResourceService } from './company-legal-entity-local-resource.service';
import { CompanyLegalEntityAnafResourceService } from './company-legal-entity-anaf-resource.service';
import { CompanyLegalEntityCofaceResourceService } from './company-legal-entity-coface-resource.service';
import { AbstractLegalEntitySearchService } from '../common/abstract-legal-entity-search.service';

@Injectable()
export class CompanyLegalEntitySearchService implements AbstractLegalEntitySearchService {
  constructor(
    private companyLegalEntityLocalResourceService: CompanyLegalEntityLocalResourceService,
    private companyLegalEntityAnafResourceService: CompanyLegalEntityAnafResourceService,
    private companyLegalEntityCofaceResourceService: CompanyLegalEntityCofaceResourceService
  ) {}

  searchLocalLegalEntity(event: { query: string }): Observable<JsonApiResource<LegalEntityModel[], any>> {
    const trimmedQuery = event.query.toString().trim();
    const numericQuery = trimmedQuery.replace(/\D/g, '') || null;

    const query = {
      filters: {
        companyName: {
          value: trimmedQuery,
          matchMode: 'contains'
        },
        uniqueIdentificationNumber: {
          value: numericQuery,
          matchMode: 'contains'
        }
      },
    };

    return this.companyLegalEntityLocalResourceService.findAllLocalLegalEntity(query);
  }

  searchAnafLegalEntity(event: { query: string }): Observable<JsonApiResource<LegalEntityModel[], any>> {
    return this.companyLegalEntityAnafResourceService.findAllAnafLegalEntity(event.query);
  }

  searchCofaceLegalEntity(
    countryIsoCode: string,
    vatCode: string
  ): Observable<JsonApiResource<LegalEntityModel[], any>> {
    return this.companyLegalEntityCofaceResourceService.findAllCofaceLegalEntity(countryIsoCode, vatCode);
  }
}
